module.exports = __webpack_public_path__ + "static/media/Apr23-S20.30d3db65.png";